import AcessoNegado from '@/components/AcessoNegado/acessoNegado.pt-br.i18n.json'
import AcompanhamentoTempoReal from '@/components/AcompanhamentoTempoReal/acompanhamentoTempoReal.pt-br.i18n.json'
import FarolDoDP from '@/components/FarolDoDP/farol-do-dp.pt-br.i18n.json'
import Auditoria from '@/components/Auditor/auditoria.pt-br.i18n.json'
import Faturas from '@/typescript/modulos/tiosam/faturas/faturas.pt-br.i18n.json'
import Compartilhados from '@/common/compartilhados.pt-br.i18n.json'
import Bora from '@/common/Bora/bora.pt-br.i18n.json'
import Biometria from '@/components/FaceBiometric/facebiometric.pt-br.i18n.json'
import BiometriaCadastro from '@/typescript/modulos/estrutura-de-pontos-da-empresa/biometria/apresentacao/biometria.pt-br.i18n.json'
import Coletor from '@/components/Coletores/coletor.pt-br.i18n.json'
import CustomizacoesDeCalculo from '@/components/CustomizacoesDeCalculo/customizacao.pt-br.i18n.json'
import Compman from '@/components/CompMan/compman.pt-br.i18n.json'
import Dashboards from '@/components/DashBoards/dashboards.pt-br.i18n.json'
import Dispositivos from '@/components/Devices/dispositivos.pt-br.i18n.json'
import Empregado from '@/components/Employee/employee.pt-br.i18n.json'
import Empregador from '@/components/Employer/employer.pt-br.i18n.json'
import FeriasEAfastamentos from '@/components/FeriasEAfastamentos/feriasEAfastamento.pt-br.i18n.json'
import LocalDeTrabalho from '@/components/Company/local.pt-br.i18n.json'
import RegraAprovacao from '@/components/ApprovalsRules/regraAprovacao.pt-br.i18n.json'
import Solicitacao from '@/components/Approvals/i18n/solicitacao.pt-br.i18n.json'
import Comuns from '@/typescript/servicos/i18n/locales/comuns.pt-br.i18n.json'
import Home from '@/components/Home/home.pt-br.i18n.json'
import MainHeader from '@/components/MainHeader/mainHeader.pt-br.i18n.json'
import MenuLateral from '@/common/MenuLateral/menuLateral.pt-br.i18n.json'
import ControleDeEstacoes from '@/components/ControleDeEstacoes/controleDeEstacoes.pt-br.i18n.json'
import Cognito from '@/components/Cognito/cognito.pt-br.i18n.json'
import CentralAtendimento from '@/components/CentralAtendimento/centralAtendimento.pt-br.i18n.json'
import Groups from '@/components/Groups/groups.pt-br.i18n.json'
import Holiday from '@/components/Holiday/holiday.pt-br.i18n.json'
import Journey from '@/components/Journey/journey.pt-br.i18n.json'
import Locker from '@/components/Locker/locker.pt-br.i18n.json'
import LogDeOperacoes from '@/components/LogDeOperacoes/logDeOperacoes.pt-br.i18n.json'
import HourBankRules from '@/components/HourBankRules/hourBankRules.pt-br.i18n.json'
import FileManagement from '@/components/FileManagement/fileManagement.pt-br.i18n.json'
import LockerRules from '@/components/LockerRules/lockerRules.pt-br.i18n.json'
import MassChanges from '@/components/MassChanges/massChanges.pt-br.i18n.json'
import PainelDePontos from '@/components/PainelDePontos/paineldepontos.pt-br.i18n.json'
import Permissions from '@/components/Permissions/permissions.pt-br.i18n.json'
import Reason from '@/components/Reason/reason.pt-br.i18n.json'
import Reports from '@/components/Reports/reports.pt-br.i18n.json'
import Routine from '@/components/Routine/routine.pt-br.i18n.json'
import Sheets from '@/components/Sheets/sheets.pt-br.i18n.json'
import User from '@/components/User/user.pt-br.i18n.json'
import Whb from '@/components/Whb/whb.pt-br.i18n.json'
import workSchedule from '@/components/WorkSchedule/workSchedule.pt-br.i18n.json'
import router from '@/router/router.pt-br.i18n.json'
import store from '@/store/store.pt-br.i18n.json'
import tipos from '@/tipos/tipos.pt-br.i18n.json'
import typescript from '@/typescript/typescript.pt-br.i18n.json'
import ModuloSolicitacoes from '@/typescript/modulos/governanca/solicitacoes/solicitacoes.pt-br.i18n.json'
import ModuloFolha from '@/typescript/modulos/estrutura-de-pontos-da-empresa/Folha/folha.pt-br.i18n.json'
import PainelSolicitacoesDeHorasExtras from '@/typescript/modulos/acompanhamento/PainelSolicitacoesDeHorasExtras/painelSolicitacoesDeHorasExtras.pt-br.i18n.json'
import Utils from '@/utils/utils.pt-br.i18n.json'
import ModuloGerenciamentoDeFerias from '@/typescript/modulos/calendario-de-trabalho/GerenciamentoDeFerias/gerenciamentoDeFeria.pt-br.i18n.json'
import CalendarioAloque from '@/typescript/modulos/calendario-de-trabalho/CalendarioAloque/calendarioAloque.pt-br.i18n.json'
import ModuloRegrasDeFerias from '@/typescript/modulos/calendario-de-trabalho/RegrasDeFerias/i18n/regrasDeFerias.pt-br.i18n.json'
import LayoutE02 from '@/typescript/modulos/calculos-do-sistema/e02/layoutE02.pt-br.i18n.json'
import ParametrizadorE02 from '@/components/ParametrizadorE02/parametrizadorE02.pt-BR.i18n.json'
import ChatPoliticas from '@/components/ChatPoliticas/chatPoliticas.pt-br.i18n.json'
import ConexoesMcp from '@/typescript/modulos/governanca/ConexoesMcp/conexoesMcp.pt-br.i18n.json'
import AssistentePontotel from '@/typescript/modulos/governanca/AssistentePontotel/assistentePontotel.pt-br.i18n.json'
import CatalogoLocalDeTrabalho from '@next/modulos/estrutura-de-ponto-da-empresa/local-de-trabalho/catalogo/catalogo-local-de-trabalho.pt-br.i18n.json'
import CatalogoRegraDeCalculo from '@next/modulos/folha-de-ponto/regra-de-calculo/catalogo/catalogo-regra-de-calculo.pt-br.i18n.json'
import CatalogoEmpregador from '@next/modulos/estrutura-de-ponto-da-empresa/empregador/catalogo/catalogo-empregador.pt-br.i18n.json'
import CatalogoEmpregado from '@next/modulos/estrutura-de-ponto-da-empresa/empregado/catalogo/catalogo-empregado.pt-br.i18n.json'
import CatalogoMotivoPadrao from '@next/modulos/estrutura-de-ponto-da-empresa/motivo-padrao/catalogo/catalogo-motivo-padrao.pt-br.i18n.json'
import CatalogoGrupoDeLocaisDeTrabalho from '@next/modulos/governanca/grupo-de-locais-de-trabalho/catalogo/catalogo-grupo-de-locais-de-trabalho.pt-br.i18n.json'
import CatalogoPerfilDePermissao from '@next/modulos/governanca/perfil-de-permissao/catalogo/catalogo-perfil-de-permissao.pt-br.i18n.json'
import CatalogoUsuario from '@next/modulos/governanca/usuario/catalogo/catalogo-usuario.pt-br.i18n.json'

const mensagens: Record<string, any> = {
  ...ParametrizadorE02,
  words: {
    user: 'usuário | usuários',
    employee: 'empregado | empregados',
    company: 'local de trabalho | locais de trabalho',
    companyShortName: 'local | locais',
    employer: 'empregador | empregadores',
    supervisor: 'responsável | responsáveis',
    routine: 'escala | escalas',
    journey: 'jornada | jornadas',
    customRules: 'regra de cálculo | regras de cálculo',
    locker: 'travamento | travamentos',
    group: 'grupo | grupos',
    whbRules: 'regra de banco de horas | regras de banco de horas ',
    all: 'aplicar a todos'
  },
  acessoNegado: AcessoNegado,
  acompanhamentoTempoReal: AcompanhamentoTempoReal,
  auditoria: Auditoria,
  tiosam: { faturas: Faturas },
  farolDoDP: FarolDoDP,
  biometria: { ...Biometria, ...BiometriaCadastro },
  compartilhados: Compartilhados,
  bora: Bora,
  compman: Compman,
  coletor: Coletor,
  customizacoesDeCalculo: CustomizacoesDeCalculo,
  dashboards: Dashboards,
  dispositivos: Dispositivos,
  empregado: Empregado,
  empregador: Empregador,
  feriasEAfastamento: FeriasEAfastamentos,
  local: LocalDeTrabalho,
  regraAprovacao: RegraAprovacao,
  solicitacao: Solicitacao,
  comuns: Comuns,
  home: Home,
  mainHeader: MainHeader,
  cognito: Cognito,
  centralAtendimento: CentralAtendimento,
  groups: Groups,
  holiday: Holiday,
  journey: Journey,
  locker: Locker,
  logDeOperacoes: LogDeOperacoes,
  hourBankRules: HourBankRules,
  fileManagement: FileManagement,
  lockerRules: LockerRules,
  massChanges: MassChanges,
  paineldepontos: PainelDePontos,
  permissions: Permissions,
  reason: Reason,
  reports: Reports,
  routine: Routine,
  sheets: Sheets,
  user: User,
  whb: Whb,
  workSchedule: workSchedule,
  router: router,
  store: store,
  tipos: tipos,
  typescript: typescript,
  solicitacoes: ModuloSolicitacoes,
  folha: ModuloFolha,
  painelSolicitacoesDeHorasExtras: PainelSolicitacoesDeHorasExtras,
  utils: Utils,
  gerenciamentoDeFerias: ModuloGerenciamentoDeFerias,
  calendarioAloque: CalendarioAloque,
  regrasDeFerias: ModuloRegrasDeFerias,
  layoutE02: LayoutE02,
  MenuLateral: MenuLateral,
  controleDeEstacoes: ControleDeEstacoes,
  chatPoliticas: ChatPoliticas,
  conexoesMcp: ConexoesMcp,
  assistentePontotel: AssistentePontotel,
  srcNext: {
    folhaDePonto: {
      catalogoRegraDeCalculo: CatalogoRegraDeCalculo,
    },
    governanca: {
      catalogoGrupoDeLocaisDeTrabalho: CatalogoGrupoDeLocaisDeTrabalho,
      catalogoPerfilDePermissao: CatalogoPerfilDePermissao,
      catalogoUsuario: CatalogoUsuario
    },
    estruturaDePontoDaEmpresa: {
      catalogoLocalDeTrabalho: CatalogoLocalDeTrabalho,
      catalogoEmpregador: CatalogoEmpregador,
      catalogoEmpregado: CatalogoEmpregado,
      catalogoMotivoPadrao: CatalogoMotivoPadrao
    }
  }
}

export default mensagens
